export default __webpack_public_path__ + "Poppins-Medium.ttf?b59f6a636397975c540983a35a5b22f7";